import moment from 'moment'

moment.defineLocale('val', {
  months: ['gener', 'febrer', 'març', 'abril', 'maig', 'juny', 'juliol', 'agost', 'septembre', 'octubre', 'novembre', 'dessembre']
})

export default {
  es: {
    comparativas: 'Comparativa',
    comparative: {
      add: 'Añadir',
      delete: 'Eliminar',
      temperatura: {
        polygon: 'Temperatura Media (Polígono)',
        extent: 'Temperatura Media (Extensión)',
        difference: 'Diferencia Temperatura (Polígono - Extensión)'
      },
      vegetacion: {
        polygon: 'NDVI Medio (Polígono)',
        extent: 'NDVI Medio (Extensión)',
        difference: 'Diferencia NDVI (Polígono - Extensión)'
      },
      compare: 'Comparar polígonos',
    },
    año: 'Año',
    mes: 'Mes',
    trimestre: 'Trim.',
    grafica: "Gráfica",
    datos: "Datos",
    "poblacion-afectada": "Población Afectada",
    "area-poligono": "Área del polígono",
    fecha: "Fecha",
    opciones: "Opciones",
    "indicadores-ambientales": "Indicadores Ambientales",
    "historico-de": "Histórico de",

    "poligonos-de-busqueda": "Polígonos de Búsqueda",
    "poligonos-de-busqueda-hint": "Crea un polígono y úsalo en futuras búsquedas",

    "imprimir-ficha": "Imprimir Ficha",
    "seleccionar-año-referencia": "Seleccionar el año de referencia",
    "año-referencia": "Año de referencia",
    "limpiar-formulario": "Limpiar Formulario",
    actuacion: "Actuación",
    titulo: "Título",
    comentarios: "Comentarios",


    "modo-dia": "Modo día",
    "modo-noche": "Modo noche",

    "nivel-zoom": "Nivel de zoom",
    "cambiar-estilo": "Cambiar estilo",
    "descargar-ficha": "Descargar Ficha (PDF)",
    "filtrar-rango-valores": "Filtrar por rango de valores",
    cerrar: "Cerrar",
    consulta: "Consulta",
    consultas: "Consultas",
    extension: "Extensión",
    diferencia: "Diferencia",
    busquedas: "Búsquedas",
    historico: "Histórico",
    punto: "Punto",
    poligono: "Polígono",
    rectangulo: "Rectángulo",

    aceptar: "Aceptar",
    cancelar: "Cancelar",

    trimestres: {
      primavera: 'primavera',
      verano: 'verano',
      otonyo: 'otoño',
      invierno: 'invierno'
    },

    indicadores: {
      temperatura: "Temperatura",
      vegetacion: "Vegetación",
      albedo: "Albedo",
      humedad: "Humedad"
    },

    selecciona: {
      indicador: "Selecciona el Indicador",
      periodo: "Selecciona el período",
      ortofoto: "Selecciona la ortofoto",
      raster: "Selecciona el ráster de",
      poligono: "Selecciona un polígono de búsqueda guardado"
    },

    _busquedas: {
      nueva: "Nueva búsqueda",
      buffer: "Aplicar buffer"
    },

    velocidad: {
      fast: "Alta",
      medium: "Media",
      slow: "Baja"
    },
    
    dibuja: {
      punto: "Selecciona un punto",
      poligono: "Traza un polígono o selecciona uno de la lista"
    },

    periodos: {
      anual: "Anual",
      mensual: "Mensual",
      trimestral: "Trimestral"
    },

    "nombre-poligono": "Añade un nombre al polígono",
    "guardar-poligono": "Guardar polígono",
    "descartar-poligono": "Descartar polígono",
    "poligonos-guardados": "Polígonos guardados",
    errores: {
      "rellena-nombre": "Debe indicar un nombre",
      "poligono-repetido": "Nombre de polígono repetido"
    }
    
  },

  val: {
    comparativas: 'Comparativa',
    comparative: {
      add: 'Afegir',
      delete: 'Eliminar',
      temperatura: {
        polygon: 'Temperatura Mitjana (Polígon)',
        extent: 'Temperatura Mitjana (Extensió)',
        difference: 'Diferència Temperatura (Polígon - Extensió)'
      },
      vegetacion: {
        polygon: 'NDVI Mitjà (Polígon)',
        extent: 'NDVI Mitjà (Extensió)',
        difference: 'Diferència NDVI (Polígon - Extensin)'
      },
      compare: 'Comparar polígons',
    },
    año: 'Any',
    mes: 'Mes',
    trimestre: 'Trim.',
    grafica: "Gràfica",
    datos: "Dades",
    "poblacion-afectada": "Població afectada",
    "area-poligono": "Àrea del polígon",
    fecha: "Data",
    opciones: "Opcions",
    "indicadores-ambientales": "Indicadors Ambientals",
    "historico-de": "Històric de",

    "poligonos-de-busqueda": "Polígons de cerca",
    "poligonos-de-busqueda-hint": "Crea un polígon i fes-lo servir en futures cerques",

    "imprimir-ficha": "Imprimir Fitxa",
    "seleccionar-año-referencia": "Seleccionar l'any de referència",
    "año-referencia": "Any de referència",
    "limpiar-formulario": "Netejar Formulari",
    actuacion: "Actuació",
    titulo: "Títol",
    comentarios: "Comentaris",

    "modo-dia": "Mode diurn",
    "modo-noche": "Mode nocturn",

    "nivel-zoom": "Nivell de zoom",
    "cambiar-estilo": "Camviar estil",
    "descargar-ficha": "Descarregar Fitxer (PDF)",
    "filtrar-rango-valores": "Filtrar per rang de valors",
    cerrar: "Tancar",
    consulta: "Consulta",
    consultas: "Consultes",
    extension: "Extensió",
    diferencia: "Diferència",
    busquedas: "Cerques",
    historico: "Històric",
    punto: "Punt",
    poligono: "Polígon",
    rectangulo: "Rectangle",

    aceptar: "Acceptar",
    cancelar: "Cancel·lar",

    indicadores: {
      temperatura: "Temperatura",
      vegetacion: "Vegetació",
      albedo: "Albedo",
      humedad: "Humitat"
    },

    trimestres: {
      primavera: 'primavera',
      verano: 'estiu',
      otonyo: 'tardor',
      invierno: 'hivern'
    },

    selecciona: {
      indicador: "Selecciona l'Indicador",
      periodo: "Selecciona el període",
      ortofoto: "Selecciona l'ortofoto",
      raster: "Selecciona el ràster de",
      poligono: "Selecciona un polígon de cerca guardat"
    },

    _busquedas: {
      nueva: "Nova cerca",
      buffer: "Aplicar buffer"
    },

    velocidad: {
      fast: "Alta",
      medium: "Mitjana",
      slow: "Baixa"
    },
    
    dibuja: {
      punto: "Selecciona un punt",
      poligono: "Traça un polígon o selecciona un de la llista"
    },

    periodos: {
      anual: "Anual",
      mensual: "Mensual",
      trimestral: "Trimestral"
    },

    "nombre-poligono": "Afegeix un nom al polígon",
    "guardar-poligono": "Guardar polígon",
    "descartar-poligono": "Descartar polígon",
    "poligonos-guardados": "Polígons guardats",
    errores: {
      "rellena-nombre": "Has d'indicar un nom",
      "poligono-repetido": "Nom del polígon repetit"
    }

  },

  en: {
    comparativas: 'Comparative',
    comparative: {
      add: 'Add',
      delete: 'Delete',
      temperatura: {
        polygon: 'Temperature Average (Polygon)',
        extent: 'Temperature Average (Extent)',
        difference: 'Temperature Difference (Polygon - Extent)'
      },
      vegetacion: {
        polygon: 'NDVI Average (Polygon)',
        extent: 'NDVI Average (Extent)',
        difference: 'NDVI Difference (Polígon - Extent)'
      },
      compare: 'Compare Polygons',
    },
    año: 'Year',
    mes: 'Month',
    trimestre: 'Trim.',
    grafica: "Chart",
    datos: "Data",
    "poblacion-afectada": "Affected population",
    "area-poligono": "Polygon Area",
    fecha: "Date",
    opciones: "Options",
    "indicadores-ambientales": "Environmental Indicators",
    "historico-de": "Historical",

    "poligonos-de-busqueda": "Search Polygons",
    "poligonos-de-busqueda-hint": "Create a polygon for future searches",

    "imprimir-ficha": "Print file",
    "seleccionar-año-referencia": "Select a reference year",
    "año-referencia": "Reference year",
    "limpiar-formulario": "Clean form",
    actuacion: "Actuación",
    titulo: "Title",
    comentarios: "Comments",


    "modo-dia": "Day mode",
    "modo-noche": "Night mode",

    "nivel-zoom": "Zoom level",
    "cambiar-estilo": "Change style",
    "descargar-ficha": "Download file (PDF)",
    "filtrar-rango-valores": "Filter by range",
    cerrar: "Close",
    consulta: "Query",
    consultas: "Queries",
    extension: "Extent",
    diferencia: "Difference",
    busquedas: "Searches",
    historico: "Historical",
    punto: "Point",
    poligono: "Polygon",
    rectangulo: "Rectangle",

    aceptar: "Accept",
    cancelar: "Cancel",

    trimestres: {
      primavera: 'spring',
      verano: 'summer',
      otonyo: 'autumm',
      invierno: 'winter'
    },


    indicadores: {
      temperatura: "Temperature",
      vegetacion: "Vegetation",
      albedo: "Albedo",
      humedad: "Humidity"
    },

    selecciona: {
      indicador: "Select Indicator",
      periodo: "Select period",
      ortofoto: "Select orthoimage",
      raster: "Select raster",
      poligono: "Select a saved polygon"
    },

    _busquedas: {
      nueva: "New Search",
      buffer: "Apply buffer"
    },

    velocidad: {
      fast: "Fast",
      medium: "Medium",
      slow: "Slow"
    },
    
    dibuja: {
      punto: "Select a Point",
      poligono: "Draw a polygon or choose one from the list"
    },

    periodos: {
      anual: "Annual",
      mensual: "Monthly",
      trimestral: "Quarterly"
    },

    "nombre-poligono": "Add a name to identify the polygon",
    "guardar-poligono": "Save polygon",
    "descartar-poligono": "Discard polygon",
    "poligonos-guardados": "Saved polygons",
    errores: {
      "rellena-nombre": "You must fill polygon's name",
      "poligono-repetido": "You've already a polygon with the supplied name"
    }
  }
}


// WEBPACK FOOTER //
// ./src/locales/index.js